import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bannerService from "./bannerService";

const initialState = {
  banners: [],
  isLoading: false,
  isError: false,
  message: "",
};

export const getActiveBanners = createAsyncThunk(
  "banner/getActive",
  async (_, thunkAPI) => {
    try {
      return await bannerService.getActiveBanners();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveBanners.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getActiveBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banners = action.payload.data;
      })
      .addCase(getActiveBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = bannerSlice.actions;
export default bannerSlice.reducer;
